import { NewBadge } from "shared/app/NewBadge";

const LEAD_TAGS_NEW_UNTIL = "2026-11-15";

/**
 * Marks lead tags as new on Settings > CRM > Tags and the Leads table's Tags column,
 * then hides itself after LEAD_TAGS_NEW_UNTIL. Filled, like the verification template
 * menu's marker, so it still reads on a selected (pink) menu row.
 */
export const LeadTagsNewBadge = () => (
  <NewBadge
    destructAfterDate={LEAD_TAGS_NEW_UNTIL}
    customBadge={
      <span className="inline-flex h-[18px] items-center rounded-full bg-primary-500 px-1.5 text-[10px] font-bold text-content-1000-inverted">
        New
      </span>
    }
  />
);
